import styled from 'styled-components'
import {Table as StandardTable} from "./index";

const TableList = styled(StandardTable)`
  background: #fff;
`

export default TableList
